import { reference } from './helper/ValidatorRules'

const referenceValidator = {
  getMessage: () => 'Sorry, only latin letters, numbers (0-9), and symbols (- _) are allowed.',
  validate: value => {
    return {
      valid: reference(value),
      data: {
        required: true
      }
    }
  }
}

export default referenceValidator
